import "../stylesheets/_loader.css";
export default function LoaderFull() {
  return (
    <div className="lds-ripple mx-auto mt-10 block min-h-screen text-center">
      <div></div>
      <div></div>
    </div>
  );
}
